import styled from '@emotion/styled';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Z_INDEX } from '../../../vars';
import type { HeaderWidgetProps } from './HeaderWidget';

export interface MobileHeaderWidgetProps extends HeaderWidgetProps {
  toggleMenu: () => any;
  menuCollapsed: boolean;
}

export const MobileHeaderWidget: React.FC<MobileHeaderWidgetProps> = (props) => {
  const { toggleMenu, menuCollapsed } = props;
  return (
    <S.MobileMenu>
      <S.Icon onClick={toggleMenu} icon={menuCollapsed ? faBars : faXmark} />
    </S.MobileMenu>
  );
};

namespace S {
  export const MobileMenu = styled.div`
    label: MobileMenu;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 0;

    display: flex;
    justify-content: flex-end;
  `;

  export const Icon = styled(FontAwesomeIcon)`
    cursor: pointer;
    padding: 10px;
    z-index: ${Z_INDEX.MOBILE_HAMBURGER_ICON};
  `;
}
